(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-result"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('before-after-slider')) {
    /** Moves the divider of the before and after picture with the hidden range input. */
    class BeforeAfterSlider extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('input[type="range"]');
        if (!this.range) return;
        this.range.addEventListener('input', this.update);
        this.update();
      }

      disconnectedCallback() {
        this.range?.removeEventListener('input', this.update);
      }

      update = () => {
        this.style.setProperty('--position', `${this.range.value}%`);
      };
    }

    customElements.define('before-after-slider', BeforeAfterSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /** Opens and scrolls to the question named in the URL hash (#question-handle). */
    const openFromHash = () => {
      const id = decodeURIComponent(window.location.hash.slice(1));
      if (!id) return;
      const target = document.getElementById(id);
      if (!(target instanceof HTMLDetailsElement) || !target.classList.contains('faq-list__row')) return;
      target.open = true;
      target.scrollIntoView({ block: 'start' });
      target.querySelector('summary')?.focus({ preventScroll: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openFromHash, { once: true });
    } else {
      openFromHash();
    }
    window.addEventListener('hashchange', openFromHash);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
